import * as types from '../constants';

export function loadDepartments() {
  return {
    type: types.LOAD_DEPARTMENTS,
  };
}

export function createDepartment(data) {
  return {
    type: types.CREATE_DEPARTMENT,
    data,
  };
}

export function updateDepartment(department) {
  return {
    type: types.UPDATE_DEPARTMENT,
    department,
  };
}

export function deleteDepartment(department) {
  return {
    type: types.DELETE_DEPARTMENT,
    department,
  };
}
